import Markdown from 'react-markdown';
import { Info } from 'components/gruenland/icons/Info';
import { Package } from 'components/gruenland/icons/Package';
import { ShieldCheck } from 'components/gruenland/icons/ShieldCheck';
import { Truck } from 'components/gruenland/icons/Truck';
import { FooterCardTitle } from './atoms/FooterCardTitle';

export type FooterCardProps = {
  icon: 'FiInfo' | 'FiTruck' | 'FiPackage' | 'LuShieldCheck';
  title: string;
  text: string;
};

export const FooterCard: React.FC<FooterCardProps> = ({ icon, title, text }) => {
  return (
    <div className="flex flex-col gap-[15px]">
      {icon === 'FiInfo' && <Info width={40} height={40} />}
      {icon === 'FiTruck' && <Truck width={40} height={40} />}
      {icon === 'FiPackage' && <Package width={40} height={40} />}
      {icon === 'LuShieldCheck' && <ShieldCheck width={40} height={40} />}
      <FooterCardTitle>{title}</FooterCardTitle>
      <div className="prose">
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
};
